/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/increase.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the absolute increase of a counter field in a time window.
 *
 * @example
 * TS k8s
 * | WHERE pod == "one"
 * | STATS increase_bytes_in = SUM(INCREASE(network.total_bytes_in)) BY cluster, time_bucket = TBUCKET(10minute)
 */
const definition: FunctionDefinition = {
  type: 'time_series_agg',
  name: 'increase',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'counter_double',
          optional: false,
        },
        {
          name: 'window',
          type: 'time_duration',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'counter_integer',
          optional: false,
        },
        {
          name: 'window',
          type: 'time_duration',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'counter_long',
          optional: false,
        },
        {
          name: 'window',
          type: 'time_duration',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
